import fetch from "node-fetch"
import { apiUrl } from "../config.prod.json"

export const getStoriesCount = () => {
  return fetch(`${apiUrl}/stories/count`)
    .then(res => res.json())
    .catch(console.error)
}

export const getStories = (category, limit, LastEvaluatedKey) => {
  return fetch(`${apiUrl}/stories?${limit ?
    Object.keys(LastEvaluatedKey).length ?
      `limit=${limit}&last=${LastEvaluatedKey.last}&lastTimestamp=${LastEvaluatedKey.lastTimestamp}` :
      `limit=${limit}` :
    ""}&${category ?  `category=${category}` : ""}`)
    .then(res => res.json())
    .catch(console.error)
}

export const getStory = alias => {
  return fetch(`${apiUrl}/stories/${alias}`)
    .then(res => res.json())
    .catch(console.error)
}

export const getAttachment = alias => {
  return fetch(`${apiUrl}/attachments/${alias}`)
    .then(res => res.json())
    .catch(console.log)
}

export const getStoriesLasts = (category = "featured", chunk = null) => {
  return fetch(`${apiUrl}/stories/lasts?${chunk ? `&chunk=${chunk}` : ""}${category ? `&category=${category}` : ""}`)
    .then(res => res.json())
    .catch(console.error)
}

export const sendEmail = email => {
  return fetch(`${apiUrl}/admin/getInTouch`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      email
    })
  })
    .then(res => res.json())
    .catch(console.error)
}



// WEBPACK FOOTER //
// ./src/helpers/api.js